import { useEffect, useState } from 'react';
import { API_URL, API_KEY, ENDPOINTS } from '../../constants/api';
import { apiKey } from '../../utils/ktcUtils';
import { Link } from 'react-router-dom';
import { decodeToken, getToken } from '../../utils/TokenUtils';

const PendingOrders = () => {
  const [orders, setOrders] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState('');
  const [showModal, setShowModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('pending');
  const [comment, setComment] = useState('');

  const [showModalComplaint, setShowModalComplaint] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [complaint, setComplaint] = useState('');

  const token = getToken();
  const userId = decodeToken(token, 'id');

  const filteredOrders = orders?.filter((order) => {
    const term = searchTerm.toLowerCase();

    return (
      order.customer?.toLowerCase().includes(term) ||
      order.tell?.toLowerCase().includes(term) ||
      order.order_id?.toString().includes(term) ||
      order.delivery_address?.toLowerCase().includes(term)
    );
  });
  const user_id = 1; // replace with auth user

  const [externalName, setExternalName] = useState('');
  const selectedDriverObj = drivers?.find(
    (d) => String(d.id) === String(selectedDriver)
  );

  const isExternal = selectedDriverObj?.name
    ?.toLowerCase()
    .includes('external');

  // Common headers
  const headers = {
    'Content-Type': 'application/json',
    'x-api-key': apiKey,
  };

  // Fetch pending orders
  const fetchOrders = async () => {
    setOrders([]);
    let route = '';
    if (activeTab === 'assigned') {
      route = 'pos-assigned-orders';
    } else if (activeTab === 'completed') {
      route = 'pos-completed-orders';
    } else {
      route = 'pos-pending-orders';
    }
    const url = `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/${route}`;
    console.log('url:', url);
    try {
      const res = await fetch(url, {
        headers,
      });
      const data = await res.json();
      console.log('data:', data);
      setOrders(data.report);
    } catch (err) {
      console.error('Error fetching orders:', err);
    }
  };

  console.log('activeTab:', activeTab);

  // Fetch drivers
  const fetchOptions = async (inputId, setState) => {
    try {
      const res = await fetch(
        `${API_URL}/${ENDPOINTS.SYS}/get-dropdown-apikey/${inputId}`,
        {
          headers,
        }
      );
      const data = await res.json();
      setState(data);
    } catch (err) {
      console.error('Error fetching ${inputId}:', err);
    }
  };

  useEffect(() => {
    fetchOrders();
    fetchOptions(4154, setDrivers);
    fetchOptions(4756, setCategories);
  }, [activeTab]);

  const openModal = (order) => {
    setExternalName('');
    setLoading(false);
    setComment(order.delivery_comment);
    setSelectedOrder(order);
    setShowModal(true);
  };

  const openModalComplaint = (order) => {
    // setExternalName('');
    setLoading(false);
    //setComment(order.delivery_comment);
    setSelectedOrder(order);
    setShowModalComplaint(true);
  };

  const handleAssign = async () => {
    if (!selectedDriver) {
      alert('Please select a driver');
      return;
    }

    setLoading(true);
    const payload = {
      order_id: selectedOrder.order_id,
      delivery_id: selectedDriver,
      external_tell: externalName || '',

      comment,
      user_id: userId,
    };
    const route = 'order-assign-delivery';

    try {
      const res = await fetch(
        `${API_URL}/${ENDPOINTS.SYS}/create-apikey/${route}`,
        {
          method: 'POST',
          headers,
          body: JSON.stringify(payload),
        }
      );
      const data = await res.json();

      console.log('data:', data);

      setShowModal(false);
      setSelectedDriver('');
      fetchOrders();
    } catch (err) {
      console.error('Assign error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleComplaint = async () => {
    if (!complaint) {
      alert('Please write a complaint');
      return;
    }
    console.log('selected category:', selectedCategory);
    setLoading(true);
    const payload = {
      order_id: selectedOrder.order_id,
      delivery_id: selectedOrder.delivery_id,
      category_id: selectedCategory,
      title: '',
      complaint,
      status: 'pending',
      user_id: userId,
    };
    const route = 'register-pos_complaint';

    try {
      const res = await fetch(
        `${API_URL}/${ENDPOINTS.SYS}/create-apikey/${route}`,
        {
          method: 'POST',
          headers,
          body: JSON.stringify(payload),
        }
      );
      const data = await res.json();

      console.log('data:', data);

      setShowModalComplaint(false);
      setSelectedCategory('');
      setComplaint('');
      fetchOrders();
    } catch (err) {
      console.error('Assign error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();

    const interval = setInterval(() => {
      fetchOrders();
    }, 60000); // 60 seconds

    return () => clearInterval(interval); // cleanup
  }, [activeTab]);
  const totalPending = filteredOrders?.length || 0;

  const totalLate =
    filteredOrders?.filter((o) => o.diff_minutes > 15).length || 0;

  const totalNormal =
    filteredOrders?.filter((o) => o.diff_minutes <= 15).length || 0;

  const handleReprint = async (order) => {
    // example

    // window.open(`/pos/jaziira/pos-invoice/${order.order_id}`, "_blank");
    const url = `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/pos-reprint-order/${order.order_id}`;
    console.log('url:', url);
    try {
      const res = await fetch(url, {
        headers,
      });
      const data = await res.json();
      console.log('data:', data);
      // setOrders(data.report);
    } catch (err) {
      console.error('Error fetching orders:', err);
    }
  };

  console.log('orders:', orders);
  return (
    <div className="container mt-3">
      <ul className="nav nav-tabs mb-3 shadow-sm">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'pending' ? 'active' : ''}`}
            style={{ color: activeTab === 'pending' ? '' : '#333' }}
            onClick={() => setActiveTab('pending')}
          >
            Pending
          </button>
        </li>

        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'assigned' ? 'active' : ''}`}
            style={{ color: activeTab === 'assigned' ? '' : '#333' }}
            onClick={() => setActiveTab('assigned')}
          >
            Assigned
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'completed' ? 'active' : ''}`}
            style={{ color: activeTab === 'completed' ? '' : '#333' }}
            onClick={() => setActiveTab('completed')}
          >
            Completed
          </button>
        </li>
      </ul>
      <h4 className="mb-3 text-capitalize">{activeTab} Orders</h4>
      <div className="row mb-3">
        <div className="col-4">
          <div className="card text-center shadow-sm border-primary">
            <div className="card-body">
              <h6>Total Pending</h6>
              <h4 className="text-primary">{totalPending}</h4>
            </div>
          </div>
        </div>

        <div className="col-4">
          <div className="card text-center shadow-sm border-danger">
            <div className="card-body">
              <h6>Late Orders</h6>
              <h4 className="text-danger">{totalLate}</h4>
            </div>
          </div>
        </div>

        <div className="col-4">
          <div className="card text-center shadow-sm border-success">
            <div className="card-body">
              <h6>Normal Orders</h6>
              <h4 className="text-success">{totalNormal}</h4>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search by name, phone, order ID, or address..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      {filteredOrders?.length === 0 && (
        <p className="text-muted">No orders found.</p>
      )}
      {/* Orders */}
      <div className="row">
        {filteredOrders?.map((order) => (
          <div key={order.order_id} className="col-12 col-md-6 col-lg-4 mb-4">
            <div
              className={`card h-100 shadow-sm border ${
                order.diff_minutes > 15 ? 'border-danger' : 'border-secondary'
              }`}
              style={{
                backgroundColor:
                  order.diff_minutes > 15 ? '#fff5f5' : '#ffffff',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <div className="card-body d-flex flex-column">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h5 className="card-title mb-0">
                    <Link to={`/pos/jaziira/pos-invoice/${order.order_id}`}>
                      Invoice #{order.order_id}
                    </Link>
                  </h5>
                  {order.diff_minutes > 15 && (
                    <span className="badge bg-danger">Overdue</span>
                  )}
                </div>

                <p className="mb-1">
                  <strong>Name:</strong> {order.customer} -{' '}
                  <a href={`tel:0${order.tell}`} className="text-primary">
                    0{order.tell}
                  </a>
                </p>
                {order.delivery_name && (
                  <p className="mb-1">
                    <strong>Driver:</strong> {order.delivery_name} -{' '}
                    <a
                      href={`tel:0${order.delivery_tell}`}
                      className="text-primary"
                    >
                      0{order.delivery_tell}
                    </a>
                  </p>
                )}
                <p className="mb-1">
                  <strong>Address:</strong> {order.delivery_address}
                </p>
                <p className="mb-1">
                  <strong>Date:</strong> {order.date} -{' '}
                  <strong>
                    <span
                      className={
                        order.diff_minutes > 15 ? 'text-danger' : 'text-success'
                      }
                    >
                      {order.diff_minutes >= 60
                        ? `${Math.floor(order.diff_minutes / 60)} Hr ${
                            order.diff_minutes % 60
                          } Min`
                        : `${order.diff_minutes} Min`}
                    </span>
                  </strong>
                </p>
                <ul>
                  {order.products?.split(',').map((item, index) => (
                    <li key={index}>{item.trim()}</li>
                  ))}
                </ul>
                {order.delivery_comment && order.delivery_comment != 1 && (
                  <p className="text-danger">{order.delivery_comment}</p>
                )}
                <div className="d-flex gap-2 mt-auto">
                  {(activeTab == 'pending' || activeTab == 'assigned') && (
                    <button
                      className="btn btn-primary w-50"
                      onClick={() => openModal(order)}
                    >
                      {order?.delivery_name
                        ? 'Re-assign Driver'
                        : 'Assign Driver'}
                    </button>
                  )}
                  {order?.delivery_name && (
                    <button
                      className="btn btn-danger w-50"
                      onClick={() => openModalComplaint(order)}
                    >
                      Complaint
                    </button>
                  )}

                  {!order.delivery_name && activeTab != 'completed' && (
                    <button
                      className="btn btn-outline-secondary w-50"
                      onClick={() => handleReprint(order)}
                    >
                      Re-print
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal d-block" style={{ background: '#00000088' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Assign Driver ({selectedOrder?.id})
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                />
              </div>

              <div className="modal-body">
                <select
                  className="form-select"
                  value={selectedDriver}
                  onChange={(e) => setSelectedDriver(e.target.value)}
                >
                  <option value="">Select Driver</option>
                  {drivers?.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
                </select>
                {/* ✅ Show only if external */}
                {isExternal && (
                  <>
                    <br />
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter external driver name"
                      value={externalName}
                      onChange={(e) => setExternalName(e.target.value)}
                    />
                  </>
                )}

                <textarea
                  className="form-control mt-2"
                  placeholder="Add comment (optional)"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-success"
                  onClick={handleAssign}
                  disabled={loading}
                >
                  {loading ? 'Processing...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {showModalComplaint && (
        <div className="modal d-block" style={{ background: '#00000088' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  New Complaint ({selectedOrder?.id})
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModalComplaint(false)}
                />
              </div>

              <div className="modal-body">
                <select
                  className="form-select"
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  <option value="">Select Category</option>
                  {categories?.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
                </select>

                <textarea
                  className="form-control mt-2"
                  placeholder="Add complaint"
                  required
                  value={complaint}
                  onChange={(e) => setComplaint(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModalComplaint(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-success"
                  onClick={handleComplaint}
                  disabled={loading}
                >
                  {loading ? 'Processing...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PendingOrders;
